/* import __COLOCATED_TEMPLATE__ from './matching-locations.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */

import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { type MatchCheck } from 'embercom/objects/matching-system/match-check';
import { State } from 'embercom/models/data/matching-system/matching-constants';
interface Args {
  matchCheck: MatchCheck;
}

export default class MatchingLocationsComponent extends Component<Args> {
  get isDraft() {
    return this.args.matchCheck.state === State.Draft;
  }

  get isNotLive() {
    return this.args.matchCheck.state !== State.Live;
  }

  @tracked openSectionId = 0;

  @action openSection(id: number) {
    this.openSectionId = id;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MatchingSystem::MatchChecks::MatchingLocations': typeof MatchingLocationsComponent;
  }
}
